/**
 * Copy do interruptor «Detecção ativa» da Análise comportamental (A-15, noturna
 * 04/Set/2026). O switch estava MARCADO e o texto ao lado dizia «Desligada, nenhum
 * padrão comportamental é detectado» — um dos dois mentia. O texto agora segue o
 * estado.
 */
export function detectionStatusCopy(enabled: boolean): string {
  return enabled
    ? 'Ligada — os padrões marcados abaixo são detectados nas conversas e sinalizados ao supervisor.'
    : 'Desligada — nenhum padrão comportamental é detectado para este tenant.';
}
